export const rfmlog_api = {
  url: "operateLog",
  method: "post",
  title: "操作历史列表"
};

export const list_api = {
  url: "operateLog",
  method: "post",
  title: "操作历史列表"
};
export const type_api = {
  url: "getOperatelogReporttype",
  method: "get",
  title: "报表类型"
};



// WEBPACK FOOTER //
// ./src/views/rfm/rfmlog/desc.js